// In a client wrapper (TestimonialSectionHydrator.js)
"use client";
import dynamic from "next/dynamic";
const TestimonialSection = dynamic(() => import('./TestimonialSection'), {
  ssr: false,
  loading: () => <div style={{ minHeight: 300 }}></div>
});
export default function TestimonialSectionHydrator(props) {
  return <TestimonialSection {...props} />;
}
